import {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Modal} from 'semantic-ui-react';
import './UnexpectedErrorDialog.css';
import connected from '../connected';
import {hideErrorPage} from '../ducks/errorPage';

export class UnexpectedErrorDialog extends Component {

  static propTypes = {
    errorPage: PropTypes.shape({
      display: PropTypes.bool.isRequired,
      details: PropTypes.object,
    }),
    dispatch: PropTypes.func.isRequired
  };

  onButtonClick = () => {
    const {dispatch} = this.props;
    dispatch(hideErrorPage());
  };

  render() {
    const {errorPage: {display, details: {method, url, body, status} = {}}} = this.props;

    return (
      <Modal className="error-view" size={'small'} open={display}>
        <Modal.Header>Well, this is unexpected...</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <p>Sorry, something's gone wrong but we've been notified and we're looking to fix the issue.</p>
            <p>Please try again shortly.</p>
            {url && (
              <div>
                <p>method: {method}</p>
                <p>url {url}</p>
                <p>response status: {status}</p>
                <p>response body: {body}</p>
              </div>
            )}
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button primary onClick={this.onButtonClick}>Ok</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default connected(UnexpectedErrorDialog);